/* global showSuccessToast */
/* global showDangerToast */
/* global showInfoToast */

import React, { useState, useEffect } from "react";
import {
    getTargetByID,
    saveQualityFeedback,
    getQualityOpen,
    getQualityClose,
    getQualityQuestions,
    getQualityAnswers,
    addQualityAnswer
} from "../../api/api";

const STARS = [1, 2, 3, 4, 5];

const QualityCallModal = ({ companyID, selectedTargetItem, onSaved, selectedContact }) => {
    const [qualityEvaluation, setQualityEvaluation] = useState(0);
    const [qualityFeedback, setQualityFeedback] = useState("");
    const [qualityQuestions, setQualityQuestions] = useState([]);
    const [qualityOpen, setQualityOpen] = useState([]);
    const [qualityClose, setQualityClose] = useState([]);
    const [qualityAnswers, setQualityAnswers] = useState([]);
    const [questionRatings, setQuestionRatings] = useState([]);
    const [questionAnswers, setQuestionAnswers] = useState([]);

    useEffect(() => {
        if (!selectedTargetItem) return undefined;

        let cancelled = false;
        const targetID = selectedTargetItem.Target[0].id;
        setQuestionAnswers([]);
        setQuestionRatings([]);
        setQualityQuestions([]);
        setQualityOpen([]);
        setQualityClose([]);
        setQualityAnswers([]);
        setQualityEvaluation(selectedTargetItem.evaluation || 0);
        setQualityFeedback(selectedTargetItem.feedback || "");

        getQualityQuestions(companyID, targetID).then(response => {
            if (!cancelled) setQualityQuestions(response.data.data.getQualityQuestionListing.edges);
        });
        getQualityOpen(companyID, targetID).then(response => {
            if (!cancelled) setQualityOpen(response.data.data.getQualityOpenListing.edges);
        });
        getQualityClose(companyID, targetID).then(response => {
            if (!cancelled) setQualityClose(response.data.data.getQualityCloseListing.edges);
        });
        getQualityAnswers(companyID, selectedTargetItem.id).then(response => {
            if (!cancelled) setQualityAnswers(response.data.data.getQualityAnswerListing.edges.map(edge => edge.node));
        });

        return () => {
            cancelled = true;
        };
    }, [companyID, selectedTargetItem]);

    const handleSubmitQuality = async (e) => {
        e.preventDefault();
        if (!window.confirm("Vuoi procedere con il salvataggio definitivo della quality call?")) return;

        for (let index = 0; index < qualityQuestions.length; index++) {
            const plainData = {
                QualityQuestion: qualityQuestions[index].node.id,
                answer: questionAnswers[index],
                rating: questionRatings[index],
            };
            const qualityResponse = await addQualityAnswer(plainData, companyID, selectedTargetItem.id);
            if (!qualityResponse?.data?.data?.createQualityAnswer?.output?.id) {
                console.error("Errore: risposta non valida durante l'aggiunta della quality answer", qualityResponse);
                showDangerToast("Errore nell'aggiunta della quality answer: ");
                return;
            }
        }
        showSuccessToast("Quality call aggiunta con successo!");

        await saveQualityFeedback(selectedTargetItem.id, { feedback: qualityFeedback, evaluation: qualityEvaluation });
        showSuccessToast("Feedback salvato correttamente!");
        const response = await getTargetByID(selectedTargetItem.id);
        const updatedTarget = response.data.data.getTargetItemListing.edges[0].node;
        if (onSaved) onSaved(updatedTarget);

        window.$(document.getElementById("modal-order-item")).modal("hide");
    };

    const setAt = (setter, index, value) => setter(current => {
        const next = [...current];
        next[index] = value;
        return next;
    });

    const renderStars = (value) => STARS.map(star => (
        <i key={star} className={`ik ik-star-on ${star <= value ? "text-yellow" : "text-secondary"}`}></i>
    ));

    return (
        <div>
            <form className="row" method="post" onSubmit={handleSubmitQuality}>
                {qualityAnswers.length > 0 ? (
                    <React.Fragment>
                        <div className="form-group col-12">
                            {qualityAnswers.map((answer, index) => (
                                <div key={index} className="mb-3">
                                    <div className="row">
                                        <div className="form-group col-8 mb-0">
                                            <h6><strong>{answer.QualityQuestion[0].question}</strong></h6>
                                        </div>
                                        <div className="form-group col-4 text-right mb-0">
                                            {renderStars(answer.rating || 0)}
                                        </div>
                                        <div className="form-group col-12">
                                            <p>{answer.answer}</p>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                        <div className="form-group col-12">
                            <div className="mb-3">
                                <h6><strong>ULTERIORI DETTAGLI</strong></h6>
                                <p>{qualityFeedback}</p>
                            </div>
                        </div>
                    </React.Fragment>
                ) : (
                    <React.Fragment>
                        {qualityOpen.length > 0 && (
                            <div className="form-group col-12 mt-4">
                                {qualityOpen.map((question, index) => (
                                    <div key={index} className="mb-3">
                                        <h6><strong>{question.node.title}</strong></h6>
                                        <p>{question.node.open}</p>
                                    </div>
                                ))}
                            </div>
                        )}
                        {qualityQuestions.length > 0 && (
                            <div className="form-group col-12">
                                {qualityQuestions.map((question, index) => (
                                    <div key={index} className="my-4">
                                        <div className="row">
                                            <div className="form-group col-8 mb-0">
                                                <h6><strong>{question.node.question}</strong></h6>
                                            </div>
                                            <div className="form-group col-4 mb-0">
                                                <div className="row text-center justify-content-center">
                                                    {STARS.map(star => (
                                                        <a key={star} onClick={() => setAt(setQuestionRatings, index, String(star))} className="col-2 p-0">
                                                            <h6><i className={`ik ik-star-on ${!questionRatings[index] || questionRatings[index] < star ? "text-secondary" : "text-yellow"}`}></i></h6>
                                                        </a>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                        <p>{question.node.description}</p>
                                        <div className="d-flex gap-3">
                                            <textarea
                                                maxLength={190}
                                                className="form-control"
                                                rows={3}
                                                value={questionAnswers[index] || ""}
                                                onChange={e => setAt(setQuestionAnswers, index, e.target.value)}
                                                required
                                            />
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}
                        {qualityClose.length > 0 && (
                            <div className="form-group col-12">
                                {qualityClose.map((question, index) => (
                                    <div key={index} className="mb-3">
                                        <h6><strong>{question.node.title}</strong></h6>
                                        <p>{question.node.close}</p>
                                    </div>
                                ))}
                            </div>
                        )}
                        <div className="form-group col-12">
                            <label htmlFor="quality-feedback">Ulteriori dettagli</label>
                            <textarea
                                maxLength={190}
                                className="form-control"
                                id="quality-feedback"
                                name="feedback"
                                rows={3}
                                value={qualityFeedback}
                                onChange={e => setQualityFeedback(e.target.value)}
                                placeholder="Aggiungi un'ulteriore nota su altre impressioni o suggerimenti..."
                                required
                            />
                        </div>
                        <div className="form-group col-6 text-center text-sm-right mt-4">
                            <label className="mb-4">Valutazione finale</label>
                        </div>
                        <div className="form-group col-6 text-center text-sm-left mt-3">
                            <div className="row text-center justify-content-center justify-content-sm-start">
                                {STARS.map(star => (
                                    <a key={star} onClick={() => setQualityEvaluation(String(star))} className="col-lg-1 col-2 p-0">
                                        <h3><i className={`ik ik-star-on ${qualityEvaluation < star ? "text-secondary" : "text-yellow"}`}></i></h3>
                                    </a>
                                ))}
                            </div>
                        </div>
                        <div className="form-group col-sm-6 col-12">
                            <a href={selectedContact ? "whatsapp://send?phone=39" + selectedContact.phone + "&text=" + encodeURIComponent("Grazie per aver scelto il nostro servizio " + selectedContact.firstName.capitalize() + ". La tua opinione è fondamentale per mantenere uno strandard alto. Se vuoi condividere la tua esperienza, puoi farlo qui: https://search.google.com/local/writereview?placeid=ChIJOaBdTW4GFBMRBL5rkYvNbQo") : ""} target="_blank" rel="noreferrer" onClick={() => showInfoToast("Apertura WhatsApp in corso...")}>
                                <button type="button" className="btn btn-secondary btn-block col">Invia link recensione</button>
                            </a>
                        </div>
                        <div className="form-group col-sm-6 col-12">
                            <button type="submit" className="btn btn-primary btn-block col">Salva quality call</button>
                        </div>
                    </React.Fragment>
                )}
            </form>
        </div>
    );
};

export default QualityCallModal;
